import Swiper from 'swiper/bundle'

export default function CoverSlider () {
  const WRAPPERS = document.querySelectorAll('.mtt-cover-slider')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      createSlider(WRAPPERS[i])
    }
  }
}

function createSlider (WRAPPER) {
  let hasClicked = false
  const SWIPER_CONTAINER = WRAPPER.querySelector('.swiper-container')
  const PAGINATION_INNER = WRAPPER.querySelector('.mtt-cover-slider__pagination-inner')
  const TEXTS = PAGINATION_INNER ? PAGINATION_INNER.getAttribute('data-bullets').split(', ') : []

  const SWIPER = new Swiper(SWIPER_CONTAINER, {
    init: false,
    slidesPerView: 1,
    speed: 800,
    spaceBetween: 0,
    freeMode: false,
    watchOverflow: true,
    preloadImages: false,
    lazy: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      bulletClass: 'mtt-cover-slider__bullet',
      bulletActiveClass: 'mtt-cover-slider__bullet--active',
      renderBullet: function (i, className) {
        const INDEX = i + 1
        const NUM = INDEX > 9 ? INDEX : `0${INDEX}`
        return `<div class="${className}"><b>${NUM}</b> ${TEXTS[i]}</div>`
      }
    }
  })

  SWIPER.on('init', () => {
    if (SWIPER.slides.length > 0) {
      for (let i = 0; i < SWIPER.slides.length; i++) {
        SWIPER.slides[i].classList.remove('hide')
      }
    }
  })

  SWIPER.on('slideChange', () => { hasClicked = true })

  SWIPER.init()

  if (SWIPER.slides.length > 1) {
    setTimeout(() => {
      !hasClicked && SWIPER.slideTo(1)
    }, 5000)
  }
}
